<template>
  <div class="showData" id="showData" ref="showData" style="position: relative;z-index: 1">
    <div class="wrapper">
      <video
        src="../../../../static/video/bg_video.mp4"
        style="width: 1920px;height: 1080px;object-fit: cover;position: absolute;top: 0;left: 0;z-index: -1;"
        autoplay="autoplay"
        loop="loop"
        muted="muted"
      ></video>
      <div class="front">
        <div class="topBox">
          <div class="left">
            <img src="../../../assets/img/datas/u2021.png" />
          </div>
          <div class="middle">
            <span class="tit">榆林市智慧畜牧防疫大数据</span>
          </div>
          <div class="right">
            <div class="date">{{ nowTime }}</div>
            <!--        <div v-if="isFullScreen" class="fullBtn" @click="exitFullScreen">退出全屏</div>-->
            <div class="fullBtn" @click="fullscreenchange">{{ isFullScreen ? '退出全屏' : '全屏打开' }}</div>
          </div>
        </div>
        <div class="contentBox">
          <div class="leftBlock">
            <img class="line" src="../../../../static/images/line_topLeft.png" alt="" />
            <useStatistics :useList="useList" :useColor="useColor" @getList="getLeftList"></useStatistics>
            <totalCharts ref="totalCharts" :list="totalChartsList" :total="leftTotal"></totalCharts>
            <img class="line" src="../../../../static/images/line_bottomRight.png" alt="" />
          </div>
          <div class="centerBlock">
            <el-select
              class="selectSeason"
              v-model="taskId"
              :popper-append-to-body="false"
              @change="changeSelect"
              placeholder="请选择"
              v-if="options.length > 0"
            >
              <el-option
                class="selectSeason"
                v-for="item in options"
                :key="item.id"
                :label="createSelectDate(item)"
                :value="item.id"
                style="display: block;"
              >
                <span>{{
                  item.taskName.slice(-4) +
                    '\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0' +
                    item.startTime +
                    '--' +
                    item.endTime
                }}</span>
              </el-option>
            </el-select>
            <vaccineMap
              ref="vaccineMap"
              :pointList="pointList"
              :countrysideList="countrysideList"
              :taskId="taskId"
              @nextPart="nextPart"
            ></vaccineMap>
            <div v-if="isShowBack && !materId" class="backPrev">
              <div @click="backPrev">返回</div>
            </div>
            <div v-if="materId" class="backPrev_parent">
              <div @click="backPrev_parent">返回</div>
            </div>
            <div class="legend">
              <div
                class="legendBox"
                v-for="(legend, index) in legendList.slice(0, 12)"
                :key="index"
                @click="clickLegend(legend.id, index)"
              >
                <div class="colorBar" :style="{ backgroundColor: colors[index] }"></div>
                <div class="name" :title="legend.name">{{ legend.name }}</div>
              </div>
            </div>
          </div>
          <div class="rightBlock">
            <div class="rightTop">
              <img class="line" src="../../../../static/images/line_topRight.png" alt="" />
              <div class="title">接种畜只数量</div>
              <div class="chartsRingBox">
                <div class="chartsRing" v-for="(item, index) in chartsRingList" :key="index">
                  <chartsRing
                    :ref="`chartsRing${index}`"
                    :id-name="`chartsRing${index}`"
                    :chartsRingObj="item"
                    :livestockName="livestockName(item.livestockType)"
                    :legendList="legendList"
                  ></chartsRing>
                </div>
              </div>
              <img class="line" src="../../../../static/images/line_bottomLeft.png" alt="" />
            </div>
            <div class="rightBottom">
              <img class="line" src="../../../../static/images/line_topRight.png" alt="" />
              <div class="title">防疫工作排名</div>
              <table width="100%" cellspacing="0" cellpadding="15px">
                <tbody>
                  <tr align="left" class="header">
                    <td style="font-weight: bold;" width="50">排名</td>
                    <td style="font-weight: bold;" width="120">姓名</td>
                    <td style="font-weight: bold;" width="175">所属{{ level === '3' ? '机构' : '区县' }}</td>
                    <td style="font-weight: bold;" width="80">防疫数量</td>
                    <td width="140" v-if="level === '3' || isShowBack"></td>
                  </tr>
                </tbody>
              </table>
              <div v-if="rankList.length < 5" style="height: 290px">
                <table width="100%" cellspacing="0" cellpadding="15px">
                  <tbody>
                    <tr align="left" class="row" v-for="(item, index) in rankList" :key="index">
                      <td width="50">{{ index + 1 }}</td>
                      <td width="120">{{ item.realName }}</td>
                      <td width="175">{{ item.orgName }}</td>
                      <td width="80">{{ item.amount }}</td>
                      <td width="140" v-if="level === '3' || isShowBack">
                        <el-link type="primary" @click="getPeoplePath(item.deptId)">工作路径 ></el-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <listScroll v-else style="height: 250px" :speed="0.5" ref="listScroll">
                <table width="100%" cellspacing="0" cellpadding="15px">
                  <tbody>
                    <tr align="left" class="row" v-for="(item, index) in rankList" :key="index">
                      <td width="50">{{ index + 1 }}</td>
                      <td width="120">{{ item.realName }}</td>
                      <td width="175">{{ item.orgName }}</td>
                      <td width="80">{{ item.amount }}</td>
                      <td width="140" v-if="level === '3' || isShowBack">
                        <el-link type="primary" @click="getPeoplePath(item.deptId)">工作路径 ></el-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </listScroll>
              <img class="line" src="../../../../static/images/line_bottomLeft.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useStatistics from './component/useStatistics';
import vaccineMap from './component/vaccineMap';
import chartsRing from './component/chartsRing';
import totalCharts from './component/totalCharts';
import listScroll from './component/listScroll';
import { mapColors } from '@/utils/config';
import {
  getTaskInfoList,
  getUsageDataLivestockCount,
  selectMaterInfoList,
  getDataLivestockCount,
  findDictList,
  areaCoordinateList,
  getPcaCode,
  getRankingOfEpidemicPrevention,
  areaPersCoordinateList
} from '@/api/statistics';
export default {
  data() {
    return {
      isFullScreen: false,
      nowTime: '',
      taskId: '',
      options: [],
      useList: [],
      useColor: '',
      legendList: [],
      pcode: '', // 行政编码
      deptId: JSON.parse(localStorage.info).deptId, // 机构id1
      // deptId: 42353, // 机构id
      materId: '',
      colors: mapColors,
      chartsRingList: [],
      dictList: [],
      leftTotal: 0, // 左下总量
      totalChartsList: [], // 左下列表
      pointList: [], // 地图点位数据
      isShowBack: false, // 是否显示返回上一级按钮
      level: JSON.parse(localStorage.info).provincialAndMunicipalLevel,
      countrysideList: [], // 工作路径数组
      rankList: [],
      usageRateOrderingRule: 'desc',
      theRemainingOrderingRule: '',
      timer: null
    };
  },
  mounted() {
    this.setScale();
    document.addEventListener('fullscreenchange', () => {
      if (this.isFullScreen) {
        this.setScale(); // 退出全屏时自适应
      }
      this.isFullScreen = !this.isFullScreen;
    });
    this.nowTimes(); // 定时器
    getTaskInfoList({}).then((res) => {
      this.options = res.data.data;
      this.taskId = this.options.find((item) => item.status === 0).id;
      console.log(this.taskId, this.options)
      this.selectMaterInfoList();
    });
    this.findDictList();
  },
  methods: {
    setScale(isScreen = false) {
      let designWidth = 1920; //设计稿的宽度，根据实际项目调整
      let designHeight = 1080; //设计稿的高度，根据实际项目调整
      let scale =
        document.getElementsByClassName('wrapper')[0].clientWidth /
          document.getElementsByClassName('wrapper')[0].clientHeight <
        designWidth / designHeight
          ? document.getElementsByClassName('wrapper')[0].clientWidth / designWidth
          : document.getElementsByClassName('wrapper')[0].clientHeight / designHeight;
      document.getElementsByClassName('wrapper')[0].style.transform = `scale(${scale}) translate(${
        isScreen ? '0' : '-10%,-10%'
      })`;
      setTimeout(() => {
        scale =
          document.getElementsByClassName('wrapper')[0].clientWidth /
            document.getElementsByClassName('wrapper')[0].clientHeight <
          designWidth / designHeight
            ? document.getElementsByClassName('wrapper')[0].clientWidth / designWidth
            : document.getElementsByClassName('wrapper')[0].clientHeight / designHeight;
        document.getElementsByClassName('wrapper')[0].style.transform = `scale(${scale}) translate(${
          isScreen ? '0' : '-10%,-10%'
        })`;
      }, 100);
    },
    fullscreenchange() {
      // 最新写法
      const isFullScreen = document.fullscreenElement;
      if (isFullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          this.setScale();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          this.setScale();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          this.setScale();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
          this.setScale();
        }
      } else {
        var fullscreen = this.$refs.showData; // 需要全屏的元素
        if (fullscreen.requestFullscreen) {
          fullscreen.requestFullscreen();
          this.setScale(true);
        } else if (fullscreen.mozRequestFullScreen) {
          fullscreen.mozRequestFullScreen();
          this.setScale(true);
        } else if (fullscreen.webkitRequestFullscreen) {
          fullscreen.webkitRequestFullscreen();
          this.setScale(true);
        } else if (fullscreen.msRequestFullscreen) {
          fullscreen.msRequestFullscreen();
          this.setScale(true);
        }
      }
    },
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? '0' + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10 ? '0' + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? '0' + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? '0' + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();
      let week = new Date(timeStamp).getDay();
      let weeks = ['日', '一', '二', '三', '四', '五', '六'];
      let getWeek = '星期' + weeks[week];
      let nowTime =
        year + '年' + month + '月' + date + '日' + getWeek + ' \u00a0\u00a0\u00a0' + hh + ':' + mm + ':' + ss;
      return nowTime;
    },
    nowTimes() {
      this.nowTime = this.timeFormate(new Date());
      this.timer = setInterval(() => {
        this.nowTime = this.timeFormate(new Date());
      }, 1000);
    },
    clear() {
      setTimeout(() => {
        clearInterval(this.timer);
      }, 1000);
    },
    // 生成select选中时的样式
    createSelectDate(item) {
      return (
        '\u00a0\u00a0' +
        item.taskName.slice(-4) +
        '\u00a0\u00a0\u00a0\u00a0' +
        item.startTime
          .split('')
          .join('\u00a0\u00a0\u00a0\u00a0')
          .split('-')
          .join('\u00a0\u00a0')
      );
    },
    // 下钻的回调
    nextPart(pcode, deptId) {
      this.isShowBack = true;
      this.deptId = deptId;
      this.level = '3';
      this.pcode = pcode;
    },
    // 上钻
    backPrev() {
      if (this.countrysideList.length !== 0) {
        this.countrysideList = [];
      } else {
        this.$refs.vaccineMap.backMap();
        this.pcode = '610800';
        this.deptId = JSON.parse(localStorage.info).deptId; // 机构id
        this.level = JSON.parse(localStorage.info).provincialAndMunicipalLevel;
        this.isShowBack = false;
      }
    },
    backPrev_parent() {
      // 返回默认样式
      this.materId = '';
      this.useColor = '';
      this.getTotal(); // 获取左下
      this.getUsageDataLivestockCount(); // 获取左侧列表
      this.getDataLivestockCount(); // 获取右上数据
      this.getRankingOfEpidemicPrevention(); // 获取右下数据
    },
    // 获取图例
    selectMaterInfoList() {
      selectMaterInfoList({
        taskId: this.taskId,
        deptId: this.deptId,
        type: 1
      }).then((res) => {
        this.leftTotal = res.data.data.dataTotals;
        this.legendList = res.data.data.dataList.map((item) => {
          return {
            id: item.id,
            name: item.materName
          };
        });
        // this.materId = this.legendList.at(0) ? this.legendList.at(0).id : ''
        // console.log(this.legendList, 'this.legendList');
        // this.getDataLivestockCount() // 获取右上数据
        this.areaCoordinateList(); // 获取飞线图
      });
    },
    areaCoordinateList() {
      areaCoordinateList({
        deptId: this.deptId,
        // materId: this.materId,
        taskId: this.taskId,
        type: 1
      }).then((res) => {
        getPcaCode({ id: this.deptId })
          .then((p) => {
            this.pcode = p.data.data;
          })
          .then(() => {
            this.pointList = res.data.data;
          });
      });
    },
    // 获取左下列表
    getTotal() {
      selectMaterInfoList({
        deptId: this.deptId,
        taskId: this.taskId,
        id: this.materId,
        type: 1
      }).then((res) => {
        this.leftTotal = res.data.data.dataTotals;
        this.totalChartsList = res.data.data.dataList.slice(0, 12).map((item) => {
          return {
            name: item.materName,
            value: item.materNum,
            mixUnit: item.mixUnit,
            itemStyle: {
              color: this.colors[this.legendList.findIndex((legend) => item.materName === legend.name)]
            },
            label: {
              color: this.colors[this.legendList.findIndex((legend) => item.materName === legend.name)],
              fontSize: '13px',
              fontWeight: 600,
              formatter: '{name|{b}}\n{count|{c} ' + item.mixUnit + '}',
              // formatter: function (params) {
              //   console.log(params)
              //   return params.data.name + '\n' + params.data.value + '(' + params.data.mixUnit + ')'
              // },
              rich: {
                name: {
                  fontSize: 15,
                  color: '#fff',
                  align: 'center'
                },
                count: {
                  fontSize: 15,
                  padding: [10, 0, 0, 0],
                  align: 'center'
                }
              }
            }
          };
        });
        this.$refs.totalCharts.init();
      });
    },
    changeSelect() {
      this.materId = '';
      this.useColor = '';
      this.selectMaterInfoList(); // 获取图例 => 图例、左上 右上 飞线
      this.getTotal(); // 获取左下
      this.getDataLivestockCount(); // 获取右上数据
      this.getRankingOfEpidemicPrevention(); // 获取右下数据
      this.getUsageDataLivestockCount(); // 获取左侧列表
    },
    // 获取左侧列表
    getLeftList(usageRateOrderingRule, theRemainingOrderingRule) {
      this.usageRateOrderingRule = usageRateOrderingRule;
      this.theRemainingOrderingRule = theRemainingOrderingRule;
      this.getUsageDataLivestockCount();
    },
    getUsageDataLivestockCount() {
      getUsageDataLivestockCount({
        taskId: this.taskId,
        deptId: this.deptId,
        materId: this.materId,
        type: 1,
        usageRateOrderingRule: this.usageRateOrderingRule,
        theRemainingOrderingRule: this.theRemainingOrderingRule
      }).then((res) => {
        this.useList = res.data.data;
      });
    },
    clickLegend(id, index) {
      this.materId = id;
      this.getTotal(); // 获取左下
      this.getUsageDataLivestockCount(); // 获取左侧列表
      this.getDataLivestockCount(); // 获取右上数据
      this.getRankingOfEpidemicPrevention(); // 获取右下数据
      this.useColor = this.colors[index];
    },
    // 获取右上数据
    getDataLivestockCount() {
      getDataLivestockCount({
        deptId: this.deptId,
        materId: this.materId,
        taskId: this.taskId,
        type: 1
      })
        .then((res) => {
          console.log(res.data.data, 'res.data.data')
          if (res.data.data.length !== 0) {
            let list = [
              {
                livestockNum: 0,
                livestockType: 1,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 2,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 3,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 4,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 5,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 0,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              }
            ];
            res.data.data.forEach((item) => {
              list.forEach((item2, index2) => {
                if (item.livestockType === item2.livestockType && item.materCountList) {
                  list[index2] = item;
                }
              });
            });
            this.chartsRingList = list;
          } else {
            this.chartsRingList = [
              {
                livestockNum: 0,
                livestockType: 1,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 2,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 3,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 4,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 5,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              },
              {
                livestockNum: 0,
                livestockType: 0,
                materCountList: [
                  {
                    livestockType: 0,
                    materId: 0,
                    materName: '',
                    materNum: 0
                  }
                ]
              }
            ];
          }
        })
        .then(() => {
          this.chartsRingList.forEach((item, index) => {
            this.$refs[`chartsRing${index}`][0].initMap();
          });
        });
    },
    // 查询字典表
    findDictList() {
      findDictList({
        code: 'livestock_type'
      }).then((res) => {
        this.dictList = res.data.data[0].children;
      });
    },
    livestockName(livestockType) {
      return this.dictList.find((item) => {
        return item.code == livestockType;
      }).valueDesc;
    },
    getPeoplePath(deptId) {
      // console.log(deptId)
      areaPersCoordinateList({
        deptId: deptId,
        materId: this.materId,
        taskId: this.taskId,
        type: 1
      }).then((res) => {
        this.$set(this, 'countrysideList', res.data.data);
        this.$refs.vaccineMap.initCountryside();
      });
    },
    // 获取右下
    getRankingOfEpidemicPrevention() {
      getRankingOfEpidemicPrevention({
        materId: this.materId,
        deptId: this.deptId,
        taskId: this.taskId,
        pcode: this.pcode,
        provincialAndMunicipalLevel: this.level
      }).then((res) => {
        this.rankList = res.data.data;
        if (this.rankList.length > 5) {
          this.$nextTick(() => {
            this.$refs.listScroll.toScroll();
          });
        }
      });
    }
  },
  watch: {
    pcode(val) {
      this.getTotal(); // 获取左下
      this.getUsageDataLivestockCount(); // 获取左侧列表
      this.getDataLivestockCount(); // 获取右上数据
      this.getRankingOfEpidemicPrevention(); // 获取右下数据
    }
  },
  beforeDestroy() {
    this.clear();
  },
  components: {
    useStatistics,
    vaccineMap,
    chartsRing,
    totalCharts,
    listScroll
  }
};
</script>
<style lang="scss">
.showData {
  height: 910px;

  .wrapper {
    width: 100%;
    height: 100%;

    .front {
      width: 1860px;
      height: 1034px;
      color: #fff;
      background: url('../../../../static/images/bg_cover.png') no-repeat;
      background-size: cover;
      padding: 16px 30px 30px;

      .topBox {
        background-image: url('../../../../static/images/topTitle.png');
        background-size: cover;
        width: 100%;
        height: 76px;
        display: flex;
        justify-content: space-between;

        .left,
        .middle,
        .right {
          width: 29%;
        }

        .left {
          img {
            height: 36px;
            margin-left: 25px;
            margin-top: 22px;
          }
        }

        .middle {
          text-align: center;
          line-height: 86px;

          .tit {
            font-size: 34px;
            color: #19ecff;
          }
        }

        .right {
          display: flex;
          justify-content: space-between;
          margin-top: 18px;

          .date {
            color: #19ecff;
            font-size: 20px;
          }

          .fullBtn {
            width: 92px;
            height: 40px;
            background: #0f2733;
            border: 1px solid #00f9ee;
            font-size: 16px;
            line-height: 40px;
            color: #d9d9d9;
            font-weight: normal;
            text-align: center;
            border-radius: 10px;
            cursor: pointer;
          }
        }
      }

      .contentBox {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;

        .leftBlock {
          background: rgba(31, 43, 55, 0.4);
          width: 510px;
          height: 898px;

          .line {
            width: 44px;
          }

          .line:last-child {
            margin-left: calc(100% - 44px);
          }
        }

        .centerBlock {
          text-align: center;
          position: relative;

          .selectSeason {
            display: inline-block;
            width: 580px;

            .el-input__inner {
              //border: 1px solid #1CDFF5;
              border: none;
              border-radius: 4px;
              height: 50px;
              line-height: 50px;
              background-color: rgba(0, 0, 0, 0);
              font-size: 24px;
              color: #ffffff;
              //background-color: red;
              background-image: url('../../../../static/images/bg_select.png');
              background-repeat: no-repeat;
              background-size: contain;
            }

            .el-input__suffix {
              width: 38px;
            }

            .el-icon-arrow-up:before {
              content: '\e78f';
              color: #00f9ee;
            }

            .el-select-dropdown {
              //top: 40px !important;
              background-color: rgba(0, 27, 25, 0.6);
              border: 2px solid #00f9ee;
              text-align: center;

              .el-scrollbar {
                .el-select-dropdown__wrap {
                  .el-scrollbar__view {
                    .el-select-dropdown__item {
                      color: #ffffff;
                      font-size: 24px;
                    }

                    .selected,
                    .hover {
                      background: #00f9ee;
                      color: #000000;
                    }
                  }
                }
              }

              .popper__arrow {
                border-bottom-color: transparent;
              }

              .popper__arrow::after {
                border-bottom-color: transparent;
              }
            }
          }

          .backPrev {
            div {
              width: 88px;
              height: 38px;
              border: 1px solid #00f9ee;
              border-radius: 10px;
              text-align: center;
              line-height: 38px;
              cursor: pointer;
              margin: 0 auto;
            }
          }

          .backPrev_parent {
            div {
              width: 88px;
              height: 38px;
              border: 1px solid #00f9ee;
              border-radius: 10px;
              text-align: center;
              line-height: 38px;
              cursor: pointer;
              margin: 0 auto;
              // position: absolute;
              // bottom: 136px;
              // left: 50%;
              // transform: translate(-50%);
            }
          }

          .legend {
            width: 95%;
            margin: auto;
            margin-top: 24px;

            .legendBox {
              display: inline-block;
              align-items: center;
              font-size: 15px;
              margin-bottom: 10px;
              width: 195px;
              cursor: pointer;

              .colorBar {
                display: inline-block;
                width: 18px;
                height: 18px;
                border-radius: 4px;
              }

              .name {
                display: inline-block;
                width: 145px;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            //.legendBox:nth-child(2),.legendBox:nth-child(3),.legendBox:nth-child(6),.legendBox:nth-child(7),.legendBox:nth-child(10),.legendBox:nth-child(11), {
            //  margin-left: 18px;
            //  margin-right: 18px;
            //}
          }
        }

        .rightBlock {
          width: 510px;

          .rightTop {
            width: 510px;
            //background-color: #0F2733;
            background: rgba(31, 43, 55, 0.4);

            .line:first-child {
              width: 44px;
              margin-left: 90%;
            }

            .line:last-child {
              width: 44px;
              margin-right: 100%;
            }

            .title {
              font-size: 20px;
              font-weight: bold;
              padding-left: 22px;
              padding-bottom: 15px;
            }

            .chartsRingBox {
              width: calc(100% - 40px);
              height: 320px;
              padding: 0 20px;
              display: flex;
              flex-wrap: wrap;
              $gulp: calc((100% - (120px * 3)) / 2);

              .chartsRing {
                width: 120px;
                height: 160px;
              }

              .chartsRing:nth-child(2),
              .chartsRing:nth-child(5) {
                margin: 0 $gulp;
              }
            }
          }

          .rightBottom {
            margin-top: 20px;
            width: 100%;
            //height: 400px;
            //background-color: #0F2733;
            background: rgba(31, 43, 55, 0.4);

            .line:first-child {
              width: 44px;
              margin-left: 90%;
            }

            .line:last-child {
              width: 44px;
              margin-right: 100%;
            }

            .title {
              font-size: 20px;
              font-weight: bold;
              padding-left: 22px;
              padding-bottom: 20px;
            }

            table {
              .header {
                background: rgba(102, 255, 255, 0.2);
                font-size: 12px;
                color: #66ffff;
                padding: 12px 15px 0;
              }

              .row {
                font-size: 14px;
              }

              .row:nth-child(even) {
                background: rgba(102, 255, 255, 0.1);
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/SmartLivestock-zzry/statisticsLevel/showDataLevle.vue